import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import TableDragSelect from "react-table-drag-select";
import HelpOutlineOutlinedIcon from "@material-ui/icons/HelpOutlineOutlined";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import { CircularProgress, Tooltip, Box } from "@material-ui/core";
import { green } from "@material-ui/core/colors";
import moment from "moment";
import isEqual from "lodash/_baseIsEqual";
import axios from "axios";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import css from "../../../../sass/grid_style.module.scss";
import { getWeekDayNum, getRealyUpdated } from "../../lib/helperFuncs.jsx";
import { MATERIAL_UI_PROPS, STATE_DATE_FORMAT } from "../../lib/data";
import RoomRatesEditor from "../RoomRatesEditor/RoomRatesEditor.jsx";
import Toolbar from "./connectedComponents/Toolbar.jsx";
import RoomRateEditByRule from "./connectedComponents/RoomRateEditByRule.jsx";
import CopiedColInfoModule from "./connectedComponents/CopiedColInfoModule.jsx";
import ClossingMassEditor from "./connectedComponents/ClossingMassEditor.jsx";

import ModalRepriceInherited from "../Modal/ModalRepriceInherited.jsx";
import ModalAutoInherit from "../Modal/ModalAutoInherit.jsx";
import ModalStatus from "../Modal/ModalStatus.jsx";
import ModalSelectionRatesAndRoomTypes from "../Modal/ModalSelectionRatesAndRoomTypes.jsx";

const RoomRateGrid = (props) => {
    const [editFormVisible, setEditFormVisible] = useState(false);
    const [cells, setCells] = useState([]);
    const [gridValues, setGridValues] = useState({});
    const [filteredItems, setFilteredItems] = useState({});
    const [toolbarIsOpen, setToolbarIsOpen] = useState(false);
    const [copyIsEnabled, setCopyIsEnabled] = useState(false);
    const [copiedCellColVals, setCopiedCellColVals] = useState({});
    const [copiedColInfo, setCopiedColInfo] = useState({
        open: false,
        date: "",
    });
    const [modalActive, setModalActive] = useState(false);
    const [modalInheritActive, setModalInheritActive] = useState(false);
    const [needSavedBanned, setNeedSavedBanned] = useState(true);
    const [fromUploadPrices, setFromUploadPrices] = useState(false);
    const [inherit, setInherit] = useState([]);
    const [modalResponse, setModalResponse] = useState([]);
    const [rePriceData, setRePriceData] = useState([]);
    const [datesToUpdate, setDatesToUpdate] = useState([]);
    const [variantVectorClose, setVariantVectorClose] = useState(null);

    const [modalStatus, setModalStatus] = useState(null);

    const [accomodTypes, setAccomodTypes] = useState(props.accomodTypes);

    const [modalOpen, setModalOpen] = useState(false);
    const [pendingFormData, setPendingFormData] = useState(null);

    const toggleModalAutoInherit = (e) => {
        e.preventDefault();
        if (modalInheritActive) {
            props.reload();
        }
        setModalInheritActive(!modalInheritActive);
    };
    const getSelectedCells = () => {
        const selectedCells = document.querySelectorAll(".cell-selected");
        const uniqueDates = Array.from(selectedCells).reduce((dates, cell) => {
            const date = cell.getAttribute("date");
            if (date && !dates.includes(date)) {
                dates.push(date);
            }
            return dates;
        }, []);
        return uniqueDates;
    };

    // Check if props.filteredItems and filteredItems are same to prevent re-renders
    useEffect(() => {
        if (isEqual(filteredItems, props.filteredItems)) return;
        setFilteredItems({ ...props.filteredItems });
        setGridValues(
            createGridValues(
                props.month,
                props.roomType,
                props.filteredItems,
                props.accomodTypes,
                props.objectTemplate,
                props.rate.id,
                props.closeSale,
                props.daysInMonth,
            ),
        );
    }, [props.filteredItems]);

    // Makes sure that picked month is in gridValues
    useEffect(() => {
        setCopiedCellColVals({});
        setCopiedColInfo({
            date: "",
            open: false,
        });
        setGridValues(
            createGridValues(
                props.month,
                props.roomType,
                props.filteredItems,
                props.accomodTypes,
                props.objectTemplate,
                props.rate.id,
                props.closeSale,
                props.daysInMonth,
            ),
        );

        setTimeout(() => {
            const enabledCell = document.querySelector(".cell-enabled");

            if (enabledCell) {
                enabledCell.scrollIntoView({
                    block: "end",
                });
            }
        }, 100);

        return clearTimeout();
    }, [props.rate, props.roomType, props.month, props.daysInMonth]);

    // Check if there are errorFields, if are re-renders table with added results
    useEffect(() => {
        if (!props.errorFields) return;
        setGridValues(
            updateGridWithResults(
                gridValues,
                props.errorFields.items,
                props.rate.id,
            ),
        );
        setCells(props.cells);
    }, [props.errorFields]);

    // Check if props.cell and cells are equal, if they aren't re-renders grid
    useEffect(() => {
        if (isEqual(cells, props.cells)) return;
        setCells(props.cells);
    }, [props.cells]);

    // Return inherited rates
    useEffect(() => {
        let rateId = props.rate.id;
        axios
            .post("/manager/data/hotels/search_inherit_rates", {
                data: rateId,
            })
            .then((res) => res.data)
            .then((resBody) => {
                setInherit(resBody);
            });
    }, [props.rate.id]);

    // Reprice send server
    useEffect(() => {
        if (rePriceData.length !== 0) {
            axios.post("/manager/data/hotels/reprice_inherit_rates", {
                dataBase: rePriceData,
                dataInherit: modalResponse,
            });
        }
    }, [modalResponse]);

    // Opens and passes picked cells to updateHandler
    const quotasEditHandler = (pickedCells) => {
        const checkedVal = checkIfThereAreSelectedCells(pickedCells);

        // Opens and closes toolbar
        if (checkedVal && !toolbarIsOpen) {
            setToolbarIsOpen(() => true);
        } else if (!checkedVal && toolbarIsOpen) {
            setToolbarIsOpen(false);
        }
        setCells(pickedCells);

        const cellsWithSelectedVal =
            document.querySelectorAll(".cell-selected");
        // Enables and disables copying from cells

        if (
            cellsWithSelectedVal.length === 1 &&
            cellsWithSelectedVal[0].textContent &&
            cellsWithSelectedVal[0].textContent != "0"
        ) {
            return setCopyIsEnabled(true);
        }

        setCopyIsEnabled(false);
    };

    const handleStatusUpload = () => {
        axios
            .get(
                import.meta.env.VITE_API_PRICE_LOADER_URL +
                    "/progress?hotelId=" +
                    props.objectTemplate.hotel_id,
            )
            .then((res) => {
                if (res.data?.error) {
                    alert(res.data.error);
                    // setModalStatus(false)
                } else if (res?.data && res.data.length > 0) {
                    alert(res.data?.join(",\n"));
                    // setModalStatus(true)
                }
                // setModalStatus(false)
            });
    };

    //Массовое открытие\закрытие продаж
    const updateModalHandler = (e) => {
        e.preventDefault();
        props.openMassClossingHandler(false);

        let data = {};
        data.types = [];
        data.dates = [];
        data.rateId = props.rate.id;
        data.action = "";
        let onDates = false;

        for (let [k, v] of Object.entries(e.target)) {
            if (v.id === "dateMassStart" || v.id === "dateMassEnd") {
                onDates = true;
                continue;
            }

            if (v.localName === "fieldset") {
                onDates = false;
                continue;
            }

            if (v.id === "closeMassSales" && v.checked) {
                data.action = "close";
                break;
            } else if (v.id === "openMassSales" && v.checked) {
                data.action = "open";
                break;
            }

            if (v.localName === "input" && !onDates && v.checked) {
                data.types.push(v.id);
            } else if (v.localName === "input" && onDates && v.checked)
                data.dates.push(v.id);
        }

        axios.post(
            "/manager/data/hotels/" +
                props.objectTemplate.hotel_id +
                "/room_rates/mass_closing",
            {
                data: data,
            },
        );

        const realyUpdated = getRealyUpdated(gridValues[props.roomType.id]);

        for (const [key, value] of Object.entries(realyUpdated)) {
            for (const [k, v] of Object.entries(value)) {
                if (data.dates.includes(k) && v.id !== null) {
                    let el = document.getElementById(v.id);
                    if (!el) {
                        continue;
                    }
                    if (
                        data.action === "open" &&
                        el.style.backgroundColor !== "pink"
                    ) {
                        el.classList.remove("room-rates-cell-closed");
                        el.style.backgroundColor = "#ddd";
                    } else {
                        el.classList.add("room-rates-cell-closed");
                        el.style.backgroundColor = "rgb(246, 166, 103)";
                    }
                }
            }
        }
    };

    // After clicking edit, opens edit form and closes toolbar
    const toolbarHandler = () => {
        setEditFormVisible(true);
        setToolbarIsOpen(false);
    };
    // After clicking cancel, removes toolbar and all selected cells
    const hideToolbarHandler = () => {
        setToolbarIsOpen(false);
        setCells(props.cells);
    };
    // After clicking copy, copies value of selected cell and then unselect it
    const copyCellValueHandler = () => {
        const selCellCoords = {};
        const selColumnVals = [];

        for (let ridx = 1; ridx < cells.length; ridx++) {
            for (let cidx = 1; cidx < cells[ridx].length; cidx++) {
                if (cells[ridx][cidx]) {
                    selCellCoords.row = ridx;
                    selCellCoords.column = cidx;
                    break;
                }
            }
        }

        let cloneM = props.month.clone();
        let oldDaysInM = 0;
        let step = 1;

        for (let j = 1; j <= selCellCoords.column; j++) {
            if (j == selCellCoords.column)
                var newColumn = cloneM.format(
                    `YYYY-MM-${postZero(j - oldDaysInM)}`,
                );

            if (j - oldDaysInM == cloneM.daysInMonth()) {
                oldDaysInM += cloneM.daysInMonth();
                cloneM.add(1, "month");
            }
        }

        for (let i = 0; i < props.accomodTypes.length; i++) {
            const valToAdd =
                gridValues[props.roomType.id][props.accomodTypes[i]][newColumn];

            Reflect.deleteProperty(valToAdd, "id");

            selColumnVals.push({
                accType: props.accomodTypes[i],
                value: gridValues[props.roomType.id][props.accomodTypes[i]][
                    newColumn
                ],
            });
        }

        setCopiedColInfo({
            date: moment(selColumnVals[0].value.date, STATE_DATE_FORMAT),
            open: true,
        });
        setCopiedCellColVals(selColumnVals);
        setCopyIsEnabled(false);
        setCells(props.cells);
    };
    // After clicking paste, pastes copied value to selected cells
    const pasteCopiedCellValue = () => {
        const selColumns = new Set();

        for (let ridx = 1; ridx < cells.length; ridx++) {
            for (let cidx = 1; cidx < cells[ridx].length; cidx++) {
                if (cells[ridx][cidx]) {
                    selColumns.add(cidx);
                    continue;
                }
            }
        }

        const updatedGridValsJson = JSON.stringify({
            ...gridValues[props.roomType.id],
        });
        const updatedGridVals = JSON.parse(updatedGridValsJson);
        const itemsToSend = [];
        const datesForUpdates = [];
        let cloneM = props.month.clone();
        let oldDaysInM = 0;
        selColumns.forEach((selColumn) => {
            for (let v = 1; v <= selColumn; v++) {
                if (v == selColumn) {
                    copiedCellColVals.forEach((val) => {
                        if (val.value.amount) {
                            const valToCopy = { ...val.value };
                            // const valDate = moment(valToCopy.date, STATE_DATE_FORMAT);
                            const thisDate = cloneM.format(
                                `YYYY-MM-${postZero(v - oldDaysInM)}`,
                            );
                            valToCopy.date = thisDate;

                            if (!datesForUpdates.includes(thisDate))
                                datesForUpdates.push(thisDate);

                            valToCopy.loadingUpdate = true;

                            updatedGridVals[val.accType][valToCopy.date] =
                                valToCopy;
                            itemsToSend.push(valToCopy);
                        }
                    });
                }
                if (v - oldDaysInM === cloneM.daysInMonth()) {
                    oldDaysInM += cloneM.daysInMonth();
                    cloneM.add(1, "month");
                }
            }
        });

        const gridToSet = { [props.roomType.id]: updatedGridVals };
        setGridValues(gridToSet);
        const result = confirm(
            "Применить копирование таких же дат для всех категорий?",
        );
        if (result) {
            axios.post(
                "/manager/data/hotels/" +
                    props.objectTemplate.hotel_id +
                    "/copy_prices_all_types",
                {
                    dateCopy: copiedColInfo.date.format("Y-M-D"),
                    datePast: datesForUpdates,
                    rate: props.rate.id,
                    selectType: props.roomType.id,
                },
            );
        }

        props.updateData(itemsToSend);
    };

    // Closes edit form
    const closeEditForm = () => {
        setCells(props.cells);
        setEditFormVisible(false);
    };

    // Close sales
    const closeSaleHandler = (fromVector = false, action = "") => {
        setToolbarIsOpen(false);
        const updatedGrid = { ...gridValues[props.roomType.id] };
        const itemsToUpdate = [];
        let isUpdated = false;
        var stop = false;
        const newActive = action == "close" ? 2 : 1;

        const realyUpdated = getRealyUpdated(updatedGrid);
        cells.forEach((row, rowIndex) => {
            if (rowIndex === 0) return;
            var cloneMonth = props.month.clone();
            var oldDaysInMonth = 0;
            var progress = 1;
            row.forEach((col, colIndex) => {
                if (colIndex === 0) return;
                if (col) {
                    for (let i = progress; i <= props.daysInMonth; i++) {
                        if (i == colIndex) {
                            isUpdated = true;
                            const [gridRow, gridCol] = getGridIndexes(
                                rowIndex - 1,
                                cloneMonth.format(
                                    `YYYY-MM-${postZero(
                                        colIndex - oldDaysInMonth,
                                    )}`,
                                ),
                                realyUpdated,
                            );
                            const updatedItem = {
                                ...updatedGrid[gridRow][gridCol],
                            };
                            if (!updatedItem.id) {
                                if (!stop) {
                                    alert(
                                        "Выберите клетки с заполненной ценой, для закрытия продажи",
                                    );
                                    stop = true;
                                }
                                break;
                            }

                            let el = document.getElementById(updatedItem.id);

                            if (fromVector != undefined && fromVector == true) {
                                updatedItem.active = newActive;
                            } else {
                                if (
                                    updatedItem.active === 2 ||
                                    el.style.backgroundColor ==
                                        "rgb(246, 166, 103)"
                                ) {
                                    el.classList.remove("cell-selected");
                                    el.classList.remove(
                                        "room-rates-cell-closed",
                                    );
                                    el.style.backgroundColor = "#ddd";
                                } else {
                                    el.classList.remove("cell-selected");
                                    el.classList.add("room-rates-cell-closed");
                                    el.style.backgroundColor =
                                        "rgb(246, 166, 103)";
                                }

                                if (updatedItem.active == 2)
                                    updatedItem.active = 1;
                                else updatedItem.active = 2;
                            }

                            updatedGrid[gridRow][gridCol] = { ...updatedItem };
                            itemsToUpdate.push({ ...updatedItem });

                            progress = colIndex;
                            break;
                        }
                        if (i - oldDaysInMonth == cloneMonth.daysInMonth()) {
                            oldDaysInMonth += cloneMonth.daysInMonth();
                            cloneMonth.add(1, "month");
                        }
                    }
                }
            });
        });

        if (isUpdated) {
            const gridToSet = { [props.roomType.id]: { ...updatedGrid } };
            setGridValues(gridToSet);
            setCells(props.cells);

            if (fromVector != undefined && fromVector == true) {
                const uniqueDatesSet = new Set(
                    itemsToUpdate.map((item) => item.date),
                );
                const uniqueDatesArray = Array.from(uniqueDatesSet);
                setDatesToUpdate(uniqueDatesArray);
            } else {
                axios
                    .post("/manager/data/hotels/close_sale", itemsToUpdate)
                    .then((res) => res.data);
            }

            props.setPickedRate(props.rate);
        }
    };

    // Updates values in the grid and sends it to server
    const updateHandler = (newValue, cellsWithNewVals) => {
        setEditFormVisible(false);
        const updatedGrid = { ...gridValues[props.roomType.id] };
        const itemsToUpdate = [];
        let isUpdated = false;
        const realyUpdated = getRealyUpdated(updatedGrid);
        cellsWithNewVals.forEach((row, rowIndex) => {
            if (rowIndex === 0) return;

            var cloneMonth = props.month.clone();
            var oldDaysInMonth = 0;
            var progress = 1;
            row.forEach((col, colIndex) => {
                if (colIndex === 0) return;
                if (col) {
                    for (let i = progress; i <= props.daysInMonth; i++) {
                        if (i == colIndex) {
                            isUpdated = true;
                            const [gridRow, gridCol] = getGridIndexes(
                                rowIndex - 1,
                                cloneMonth.format(
                                    `YYYY-MM-${postZero(
                                        colIndex - oldDaysInMonth,
                                    )}`,
                                ),
                                realyUpdated,
                            );
                            const updatedItem = {
                                ...updatedGrid[gridRow][gridCol],
                                amount: newValue,
                                loadingUpdate: true,
                            };
                            updatedGrid[gridRow][gridCol] = { ...updatedItem };
                            itemsToUpdate.push({ ...updatedItem });

                            progress = colIndex;
                            break;
                        }

                        if (i - oldDaysInMonth == cloneMonth.daysInMonth()) {
                            oldDaysInMonth += cloneMonth.daysInMonth();
                            cloneMonth.add(1, "month");
                        }
                    }
                }
            });
        });
        if (isUpdated) {
            const gridToSet = { [props.roomType.id]: { ...updatedGrid } };
            setGridValues(gridToSet);
            props.updateData(itemsToUpdate);

            if (inherit.length !== 0) {
                setModalActive(true);
                setRePriceData(itemsToUpdate);
            }
        }
    };

    useEffect(() => {
        if (datesToUpdate.length !== 0) {
            const processFormData = async () => {
                const hotelId = props.objectTemplate.hotel_id;
                const formData = new FormData();
                formData.append("dates", datesToUpdate);
                formData.append("action", variantVectorClose[1]);

                switch (variantVectorClose[0]) {
                    case "p":
                        setPendingFormData(formData);
                        setModalOpen(true);
                        return;

                    case "cr":
                        formData.append("rate_id", props?.rate?.id);
                        formData.append("room_type_id", props?.roomType?.id);
                        break;

                    case "c":
                        formData.append("rate_id", props?.rate?.id);
                        break;

                    case "r":
                        formData.append("room_type_id", props?.roomType?.id);
                        break;
                }

                sendRequest(formData);
                setDatesToUpdate([]);
            };

            processFormData();
        }
    }, [datesToUpdate]);

    const handleModalConfirm = (roomTypeIds, rateIds) => {
        if (pendingFormData) {
            pendingFormData.append("room_type_ids", JSON.stringify(roomTypeIds));
            pendingFormData.append("rate_ids", JSON.stringify(rateIds));
            sendRequest(pendingFormData);
        }
        setModalOpen(false);
        setPendingFormData(null);
        setDatesToUpdate([]);
    };

    const handleModalClose = () => {
        setModalOpen(false);
        setPendingFormData(null);
        setDatesToUpdate([]);
    };

    const sendRequest = (formData) => {
        props.switchloadAfterChangeByRule();
        axios
            .post(
                `/manager/data/hotels/${props.objectTemplate.hotel_id}/close_sales_vector`,
                formData,
            )
            .then((res) => {
                if (res.data?.result == "ok") {
                    props.setVectorStart((pr) => !pr);
                    props.switchloadAfterChangeByRule();
                }
            });
    };

    const handleClosedVector = (variant, action) => {
        setVariantVectorClose([variant, action]);
        closeSaleHandler(true, action);
    };

    // Checks all main data and then creates a grid
    const mainGrid = checkBeforeCreatingTable(
        cells,
        props.roomType,
        gridValues,
        props.month,
        quotasEditHandler,
        props.onMonthSelect,
        props.accomodTypes,
        props.monthDates,
        props.rate,
        props.maxGridRows,
        props.vectorStops,
    );

    return (
        <React.Fragment>
            {true && (
                <Toolbar
                    setStatusActualRatesFilter={
                        props.setStatusActualRatesFilter
                    }
                    statusActualRatesFilter={props.statusActualRatesFilter}
                    toolbarIsOpen={toolbarIsOpen}
                    updateFormOpen={toolbarHandler}
                    removeToolbar={hideToolbarHandler}
                    copyCellValue={copyCellValueHandler}
                    handleStatusUpload={handleStatusUpload}
                    pasteCopiedCellValue={pasteCopiedCellValue}
                    copyIsEnabled={copyIsEnabled}
                    pasteIsEnabled={Object.keys(copiedCellColVals).length > 0}
                    noSelectedCells={!checkIfThereAreSelectedCells(cells)}
                    openByRulesModule={props.openByRulesModuleHandler}
                    openMassClossing={props.openMassClossingHandler}
                    closeSaleHandler={closeSaleHandler}
                    setModalInheritActive={setModalInheritActive}
                    setNeedSavedBanned={setNeedSavedBanned}
                    setFromUploadPrices={setFromUploadPrices}
                    handleClosedVector={handleClosedVector}
                    hotelId={props.objectTemplate.hotel_id}
                    roomTypeName={props?.roomType?.name}
                    rateName={props?.rate?.name}
                />
            )}
            {modalInheritActive && (
                <ModalAutoInherit
                    active={modalInheritActive}
                    reload={props.reload}
                    setActive={setModalInheritActive}
                    toggleModal={toggleModalAutoInherit}
                    rates={props.activeRates}
                    hotelId={props.objectTemplate.hotel_id}
                    key="ModalAutoInherit"
                    needSavedBanned={needSavedBanned}
                    fromUploadPrices={fromUploadPrices}
                    setFromUploadPrices={setFromUploadPrices}
                />
            )}
            {props.isOpenRulesModule && (
                <RoomRateEditByRule
                    setIsOpenRulesModule={props.openByRulesModuleHandler}
                    accomodTypes={accomodTypes}
                    baseAccomodTypes={props.accomodTypes}
                    setAccomodTypes={setAccomodTypes}
                    rulesForChange={props.rulesForChange}
                    setRulesForChange={props.setRulesForChange}
                    startCalculationWithRules={props.startCalculationWithRules}
                    rateEnd={props.rate.date_end}
                    editFormType={props.editFormType}
                    setEditFormType={props.setEditFormType}
                    roomTypes={props.roomTypes}
                />
            )}
            {props.isOpenMassClossing && (
                <ClossingMassEditor
                    roomTypes={props.roomTypes}
                    isVisible={props.isOpenMassClossing}
                    setIsOpenMassClossingHandler={props.openMassClossingHandler}
                    onSubmit={updateModalHandler}
                    rateName={props.rate.name}
                    selectedCells={getSelectedCells}
                />
            )}
            {editFormVisible && (
                <RoomRatesEditor
                    isVisible={editFormVisible}
                    onClose={closeEditForm}
                    onSubmit={updateHandler}
                    pickedCells={cells}
                />
            )}
            <CopiedColInfoModule
                data={copiedColInfo}
                openHandler={setCopiedColInfo}
            />
            {mainGrid || <CircularProgress />}
            <ModalRepriceInherited
                active={modalActive}
                setActive={setModalActive}
                modalData={inherit}
                setModalResponse={setModalResponse}
            />

            <ModalSelectionRatesAndRoomTypes
                open={modalOpen}
                onClose={handleModalClose}
                onConfirm={handleModalConfirm}
                roomTypes={props.roomTypes || []}
                activeRates={props.activeRates || []}
                roomTypeId={props?.roomType?.id}
                rateId={props?.rate?.id}
            />

            {modalStatus && (
                <ModalStatus
                    open={modalStatus}
                    setModalStatus={setModalStatus}
                />
            )}
        </React.Fragment>
    );
};

// Helper functions

const postZero = (i) => {
    if (i == 1) return "01";
    else if (i == 2) return "02";
    else if (i == 3) return "03";
    else if (i == 4) return "04";
    else if (i == 5) return "05";
    else if (i == 6) return "06";
    else if (i == 7) return "07";
    else if (i == 8) return "08";
    else if (i == 9) return "09";
    else return i;
};

/**
 * Creates grid values by room type
 *
 * @param {moment} curMoment
 * @param {Object} roomType
 * @param {Object} prices
 * @param {Array} accomodTypes
 * @param {Object} objectTemplate
 * @param {Number} rateId
 */
const createGridValues = (
    curMoment,
    roomType,
    prices,
    accomodTypes,
    objectTemplate,
    rateId,
    closeSale,
    daysInMonth,
) => {
    const grid = {};
    grid[roomType.id] = {};
    accomodTypes.forEach((accomodType) => {
        var cloneMonth = curMoment.clone();
        var oldDaysInMonth = 0;
        grid[roomType.id][accomodType] = {};
        for (let i = 1; i <= daysInMonth; i++) {
            const accomTypeArr = accomodType.split(".");
            let dateFormat = cloneMonth.format(
                `YYYY-MM-${postZero(i - oldDaysInMonth)}`,
            );
            grid[roomType.id][accomodType][dateFormat] = {
                ...objectTemplate,
                adults: parseInt(accomTypeArr[0]),
                babies: parseInt(accomTypeArr[2]),
                children: parseInt(accomTypeArr[1]),
                extra_bed: parseInt(accomTypeArr[3]),
                craddle: parseInt(accomTypeArr[4]),
                date: dateFormat,
                room_type_id: roomType.id,
                rate_id: rateId,
                close_sale: closeSale,
            };
            if (i - oldDaysInMonth === cloneMonth.daysInMonth()) {
                oldDaysInMonth += cloneMonth.daysInMonth();
                cloneMonth.add(1, "month");
            }
            // pricesgrid[roomType.id][accomodType][i  - oldDaysInMonth])
        }
    });

    if (Object.keys(prices).length === 0) return grid;
    for (let accomodType of accomodTypes) {
        if (!Object.keys(prices).includes(accomodType)) continue;
        prices[accomodType].forEach((price) => {
            // const date = +moment(price.date).format("D");
            grid[roomType.id][accomodType][price.date] = {
                ...price,
            };
        });
    }

    return grid;
};

/**
 * Appends cell update results to gridValues cells
 *
 * @param {Object} gridValues
 * @param {Object} results
 * @param {Number} rateId
 */
const updateGridWithResults = (gridValues, results, rateId) => {
    const updatedGrid = { ...gridValues };
    const roomTypeId = Object.keys(updatedGrid)[0];

    if (!results?.[roomTypeId]) return updatedGrid;
    if (!results?.[roomTypeId]?.[rateId]) return updatedGrid;

    Object.keys(results[roomTypeId][rateId]).forEach((date) => {
        const resultsByDate = results[roomTypeId][rateId][date];
        resultsByDate.forEach((resultLine) => {
            const accomodTypeinResult = `${resultLine.adults}.${resultLine.children}.${resultLine.babies}.${resultLine.extra_bed}.${resultLine.craddle}`;
            updatedGrid[roomTypeId][accomodTypeinResult][date] = {
                ...updatedGrid[roomTypeId][accomodTypeinResult][date],
                loadingUpdate: false,
                result: {
                    message: resultLine["message"],
                    success: resultLine["success"],
                },
            };
        });
    });

    return updatedGrid;
};

/**
 * Returns indexes in gridValues based on selection array
 *
 * @param {Number} rowIndex
 * @param {Number} colIndex
 * @param {Object} gridValues
 */
const getGridIndexes = (rowIndex, colIndex, gridValues) => {
    let gridRow = Object.keys(gridValues)[rowIndex];
    let gridCol = colIndex;
    return [gridRow, gridCol];
};

/**
 * Gets Rate price object from gridValues
 *
 * @param {Object} gridValues
 * @param {Number} roomTypeId
 * @param {Array} accomodTypes
 * @param {Number} rowLine
 * @param {Number} numInRow
 */

const getRatePrice = (
    gridValues,
    roomTypeId,
    accomodTypes,
    rowLine,
    numInRow,
) => gridValues[roomTypeId][accomodTypes[rowLine]][numInRow];

/**
 * Creates data in cells
 *
 * @param {Object} ratePrice
 * @param {moment} datePrice
 * @param {String} monthNum
 * @param {String} accomType
 * @param {Number} rateId
 * @param {Number} roomTypeId
 */
const createCellData = (
    ratePrice,
    datePrice,
    monthNum,
    accomType,
    rateId,
    roomTypeId,
    dataClose,
) => {
    if (!ratePrice) return { cellKey: "н/д", cellData: 0 };
    if (!moment(ratePrice.date, "YYYY-MM-D").isSame(datePrice))
        return { cellKey: "н/д", cellData: 0 };
    const resultIcon =
        isNaN(ratePrice.amount) || ratePrice.amount === null ? null : ratePrice
              .result.success ? (
            <CheckCircleOutlineIcon
                className="indicator"
                fontSize={MATERIAL_UI_PROPS.sizes.small}
                style={{
                    color: green[500],
                }}
            />
        ) : ratePrice.result.success === false ? (
            <Tooltip title={ratePrice.result.message}>
                <HelpOutlineOutlinedIcon
                    className="indicator"
                    color={MATERIAL_UI_PROPS.colors.error}
                    fontSize={MATERIAL_UI_PROPS.sizes.small}
                />
            </Tooltip>
        ) : null;

    const updateSuccess = Object.keys(ratePrice.result)
        ? ratePrice.result.success
        : null;

    const keyForCell = `/${monthNum}/${rateId}/${roomTypeId}/${accomType}/${ratePrice.amount}/${updateSuccess}/${ratePrice.loadingUpdate}`;

    return {
        cellKey: keyForCell,
        cellData: (
            <React.Fragment>
                {ratePrice.loadingUpdate ? (
                    <Box>
                        <CircularProgress size={16} />
                    </Box>
                ) : (
                    <Tooltip
                        title={
                            <>
                                {ratePrice.base_price > 0 && (
                                    <div>
                                        Базовая цена: {ratePrice.base_price}
                                    </div>
                                )}
                                {ratePrice.craddle_price > 0 && (
                                    <div>
                                        Цена за колыбель:{" "}
                                        {ratePrice.craddle_price}
                                    </div>
                                )}
                                {ratePrice.adult_price_on_beds > 0 && (
                                    <div>
                                        Цена за взрослых (EB):{" "}
                                        {ratePrice.adult_price_on_beds}
                                    </div>
                                )}
                                {ratePrice.children_price > 0 && (
                                    <div>
                                        Цена за детей:{" "}
                                        {ratePrice.children_price}
                                    </div>
                                )}
                                {ratePrice.children_price_on_beds > 0 && (
                                    <div>
                                        Цена за детей (EB):{" "}
                                        {ratePrice.children_price_on_beds}
                                    </div>
                                )}
                                {ratePrice.baby_price > 0 && (
                                    <div>
                                        Цена за младенцев:{" "}
                                        {ratePrice.baby_price}
                                    </div>
                                )}
                                {ratePrice.baby_price_on_beds > 0 && (
                                    <div>
                                        Цена за младенцев (EB):{" "}
                                        {ratePrice.baby_price_on_beds}
                                    </div>
                                )}
                                <div>
                                    <strong>Итого:</strong> {ratePrice.amount}
                                </div>
                                {dataClose && <div>{dataClose}</div>}
                            </>
                        }
                    >
                        <Box
                            display="flex"
                            justifyContent="space-around"
                            padding="5px"
                        >
                            <Box>{ratePrice.amount}</Box>

                            <Box position="relative" bottom=".1rem">
                                {resultIcon}
                            </Box>
                        </Box>
                    </Tooltip>
                )}
            </React.Fragment>
        ),
        cellLoading: ratePrice.loadingUpdate,
    };
};

/**
 * Checks all data is correct before creating grid
 *
 * @param {Array} cells
 * @param {Object} roomType
 * @param {Object} gridValues
 * @param {moment} month
 * @param {Function} onSelect
 * @param {Function} onMonthSelect
 * @param {Array} accomodTypes
 */

const checkBeforeCreatingTable = (
    cells,
    roomType,
    gridValues,
    month,
    onSelect,
    onMonthSelect,
    accomodTypes,
    datesInMonth,
    rate,
    maxGridRows,
    vectorStops,
) => {
    if (!gridValues[roomType.id]) return;
    if (Object.keys(gridValues[roomType.id]).length < 0) return;
    return (
        datesInMonth.length === cells[0].length &&
        createGrid(
            cells,
            roomType,
            gridValues,
            month,
            onSelect,
            onMonthSelect,
            accomodTypes,
            datesInMonth,
            rate,
            maxGridRows,
            vectorStops,
        )
    );
};

/**
 * Creates rate grid
 *
 * @param {Array} outerCells
 * @param {Object} outerAuxData
 * @param {Object} outerValues
 * @param {moment} outerMonth
 * @param {Function} onCellsSelect
 * @param {Function} onMonthSelect
 * @param {Array} accomodTypes
 * @param {Array} datesInMonth
 * @param {Object} pickedRate
 */

const createGrid = (
    outerCells,
    outerRoomType,
    outerValues,
    outerMonth,
    onCellsSelect,
    onMonthSelect,
    accomodTypes,
    datesInMonth,
    pickedRate,
    maxGridRows,
    vectorStops,
) => {
    const datesClosed = [];
    const dataClosed = [];
    vectorStops.forEach((v) => {
        if (
            (v.rate_id == pickedRate.id && v.room_type_id == null) ||
            (v.rate_id == pickedRate.id &&
                v.room_type_id == outerRoomType.id) ||
            (v.rate_id == null && v.room_type_id == null) ||
            (v.rate_id == null && v.room_type_id == outerRoomType.id)
        ) {
            datesClosed.push(...v.dates);
            dataClosed.push({ data: v.data, dates: v.dates });
        }
    });

    const cells = [...outerCells];
    const rateStartDate = moment(pickedRate.date_start, STATE_DATE_FORMAT);
    const rateEndDate = moment(pickedRate.date_end, STATE_DATE_FORMAT);
    const currDateMinOne = moment();
    const actualDates = datesInMonth.slice(1);
    const cssCommonCellClass = " room-rate-col-cell room-rate-td";
    const cellsCutToLayout =
        maxGridRows > cells.length ? cells : cells.slice(0, maxGridRows);

    const headerRow = createHeaderRow({
        onMonthSelect,
        actualDates,
        cells,
        cssCommonCellClass,
    });

    if (pickedRate.edit_today) currDateMinOne.subtract(1, "d");

    const bodyRows = createBodyRows({
        cellsCutToLayout,
        outerRoomType,
        outerValues,
        accomodTypes,
        actualDates,
        outerMonth,
        pickedRate,
        currDateMinOne,
        rateEndDate,
        rateStartDate,
        cssCommonCellClass,
        datesClosed,
        dataClosed,
    });

    return (
        <TableDragSelect
            style={{ position: "relative" }}
            key={outerMonth}
            value={cellsCutToLayout}
            onChange={(cellsCutToLayout) => onCellsSelect(cellsCutToLayout)}
            className={css["table-drag-select"]}
        >
            {headerRow}
            {bodyRows}
        </TableDragSelect>
    );
};

const createBodyRows = ({
    cellsCutToLayout,
    outerRoomType,
    outerValues,
    accomodTypes,
    actualDates,
    outerMonth,
    pickedRate,
    currDateMinOne,
    rateEndDate,
    rateStartDate,
    cssCommonCellClass,
    datesClosed,
    dataClosed,
}) => {
    const auxData = { ...outerRoomType };
    const values = { ...outerValues };
    const bodyCells = cellsCutToLayout.slice(1);
    const table = [];
    for (let i = 0; i < bodyCells.length; i++) {
        let stop = true;

        for (let [k, v] of Object.entries(
            values[auxData.id][accomodTypes[i]],
        )) {
            if (v.id != null) {
                stop = false;
                continue;
            }
        }

        if (stop) continue;

        let cloneMonth = outerMonth.clone();
        var oldDaysInMonth = 0;
        const row = bodyCells[i];
        const accomoTypeArr = accomodTypes[i].split(".");

        let extra = "";
        if (accomoTypeArr[3] == 1 && accomoTypeArr[4] == 0) extra = "(EB)";
        else if (accomoTypeArr[3] == 0 && accomoTypeArr[4] == 1) extra = "(CR)";
        else if (accomoTypeArr[3] == 1 && accomoTypeArr[4] == 1)
            extra = "(EB, CR)";

        const dateKey = dataClosed
            .map((item) => item.dates)
            .flat()
            .join("-");
        const accomodType = `${accomoTypeArr[0]} / ${accomoTypeArr[1]} + ${accomoTypeArr[2]} ${extra}`;
        const pricesCells = row.slice(1);
        const layoutRow = (
            <tr key={i + dateKey}>
                <td
                    key={`${i}/${0}`}
                    className="rooms-rate-first-col accTypes"
                    disabled
                    style={{ left: "0", minWidth: "105px" }}
                >
                    <Tooltip
                        title={`Взрослых: ${accomoTypeArr[0]} Детей: ${accomoTypeArr[1]} Младенцев: ${accomoTypeArr[2]}. ${extra}`}
                    >
                        <span>{accomodType}</span>
                    </Tooltip>
                </td>
                {pricesCells.map((_, idx) => {
                    const dateNum = idx - oldDaysInMonth + 1;
                    let date = cloneMonth.format(
                        `YYYY-MM-${postZero(dateNum)}`,
                    );
                    const ratePrice = getRatePrice(
                        values,
                        auxData.id,
                        accomodTypes,
                        i,
                        date,
                    );

                    var idKey = null;
                    if (values[auxData.id][accomodTypes[i]][date]) {
                        var closed =
                            values[auxData.id][accomodTypes[i]][date].active;
                        idKey = values[auxData.id][accomodTypes[i]][date].id;
                    }

                    let dataClose;
                    dataClosed.forEach((d) => {
                        if (d.dates.includes(date) && d.data) {
                            dataClose = d.data;
                        }
                    });

                    const { cellKey, cellData, cellLoading } = createCellData(
                        ratePrice,
                        actualDates[idx],
                        cloneMonth.format("M"),
                        accomodType,
                        pickedRate.id,
                        auxData.id,
                        dataClose,
                    );
                    const weekDayNum = getWeekDayNum(actualDates[idx]);

                    const dayOff =
                        (weekDayNum === 6 || weekDayNum === 0) && "day-off";

                    const cssClass = checkIfCellIsAvailable({
                        actualDates,
                        currDateMinOne,
                        rateEndDate,
                        rateStartDate,
                        idx,
                    })
                        ? cssCommonCellClass + " room-rates-cell-disabled"
                        : `${cssCommonCellClass} cell-enabled-room-rate ${dayOff}`;

                    const disabledCell =
                        checkIfCellIsAvailable({
                            actualDates,
                            currDateMinOne,
                            rateEndDate,
                            rateStartDate,
                            idx,
                        }) || cellLoading;

                    let closeCss = "";
                    // if (closed === 2) closeCss = " room-rates-cell-closed";

                    if (datesClosed.includes(date))
                        closeCss = " room-rates-cell-closed";

                    if (idx - oldDaysInMonth + 1 === cloneMonth.daysInMonth()) {
                        oldDaysInMonth += cloneMonth.daysInMonth();
                        cloneMonth.add(1, "month");
                    }

                    return (
                        <td
                            key={`${cellKey}-${idKey}-${closed}`}
                            id={idKey}
                            date={date}
                            className={cssClass + closeCss}
                            disabled={disabledCell}
                        >
                            {cellData}
                        </td>
                    );
                })}
            </tr>
        );

        table.push(layoutRow);
    }

    return table;
};

const createHeaderRow = ({
    cells,
    actualDates,
    onMonthSelect,
    cssCommonCellClass,
}) => {
    const headerCells = cells.slice(0, 1).flat();
    const headerOtherCells = headerCells.splice(1);

    return (
        <tr key={0}>
            <td
                key="Caption"
                className={`${cssCommonCellClass} rooms-rate-first-col`}
                disabled
                style={{ left: "0" }}
            >
                ВЗР/РЕБ + МЛД
            </td>
            {headerOtherCells.map((_, idx) => (
                <td
                    key={actualDates[idx].format("D/MM")}
                    className={`${cssCommonCellClass} room-rate-first-row`}
                    onClick={onMonthSelect}
                    disabled
                    title="Выбрать месяц"
                >
                    {actualDates[idx].format("D/MM")}
                </td>
            ))}
        </tr>
    );
};

/**
 *  Checks if there are selected cells
 *
 * @param {boolean[][]} cells
 * @returns boolean
 */

const checkIfThereAreSelectedCells = (cells) => {
    const cellsToCheck = cells.slice(1);

    return cellsToCheck.reduce((areTruthy, row) => {
        if (row.some((el) => el === true)) {
            areTruthy = true;
        }
        return areTruthy;
    }, false);
};

/**
 * Check if cell is editable
 * @param {object} param0
 * @returns {boolean}
 */

const checkIfCellIsAvailable = ({
    actualDates,
    currDateMinOne,
    rateEndDate,
    rateStartDate,
    idx,
}) =>
    actualDates[idx] < currDateMinOne ||
    actualDates[idx] > rateEndDate ||
    actualDates[idx] < rateStartDate;

RoomRateGrid.propTypes = {
    accomodTypes: PropTypes.array.isRequired,
    roomType: PropTypes.object.isRequired,
    filteredItems: PropTypes.object.isRequired,
    objectTemplate: PropTypes.object.isRequired,
    rate: PropTypes.object.isRequired,
    onMonthSelect: PropTypes.func.isRequired,
    updateData: PropTypes.func.isRequired,
    errorFields: PropTypes.object,
    month: PropTypes.object.isRequired,
    cells: PropTypes.array.isRequired,
    monthDates: PropTypes.array.isRequired,
    rulesForChange: PropTypes.object,
    setRulesForChange: PropTypes.func,
    startCalculationWithRules: PropTypes.func,
    editFormType: PropTypes.string.isRequired,
    setEditFormType: PropTypes.func.isRequired,
    roomTypes: PropTypes.array.isRequired,
    maxGridRows: PropTypes.number.isRequired,
    openByRulesModuleHandler: PropTypes.func.isRequired,
    isOpenRulesModule: PropTypes.bool.isRequired,
};

export default RoomRateGrid;
